@if (!isAdmin()) {
  <mat-card class="balance-card" appearance="outlined">
    <mat-card-header>
      <mat-card-title>{{
        (authService.user$ | async)?.displayName
      }}</mat-card-title>
      <mat-card-subtitle>Account Balance</mat-card-subtitle>
    </mat-card-header>
    <mat-card-content>
      <h1>
        {{ totalBalanceAmount() | currency }}
      </h1>
    </mat-card-content>
    <mat-card-actions>
      @if (totalBalanceAmount() > 0) {
        <button mat-button="filled" (click)="openPayoutRequestDialog()">
          REQUEST PAYMENT
        </button>
      } @else {
        <button mat-button disabled>NO FUNDS</button>
      }
    </mat-card-actions>
  </mat-card>
}

<h2>Payout History</h2>

<mat-divider></mat-divider>

@if (isAdmin()) {
  <app-admin-payouts-table [payouts]="payouts() || []" />
} @else {
  <app-organizer-payouts-table [payouts]="payouts() || []" />
}

<mat-divider></mat-divider>

<app-event-balances-table [balances]="balanceTableData()" />
